'use client';

import { useState } from 'react';
import Icon from '@/components/ui/AppIcon';

export default function NewsletterSubscription() {
  const [email, setEmail] = useState('');
  const [isSubmitting, setIsSubmitting] = useState(false);
  const [isSubscribed, setIsSubscribed] = useState(false);

  const handleSubmit = async (e: React.FormEvent) => {
  e.preventDefault();

  const res = await fetch('/api/subscribe', {
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify({ email }),
  });

  if (res.ok) {
    setIsSubscribed(true);
    setEmail('');
  }
};


  if (isSubscribed) {
    return (
      <div className="bg-success/10 rounded-lg p-4 sm:p-8 border border-success/20">
        <div className="flex items-center justify-center space-x-3 mb-4">
          <Icon
            name="CheckCircleIcon"
            size={32}
            variant="solid"
            className="text-success"
          />
          <h3 className="font-headline text-2xl font-semibold text-success">
            Successfully Subscribed!
          </h3>
        </div>
        <p className="font-body text-base text-text-secondary text-center leading-relaxed">
          Thank you for subscribing to our quarterly updates. You'll receive the latest insights on our transformation agenda and impact metrics.
        </p>
      </div>
    );
  }

  return (
    <div className="bg-card rounded-lg shadow-institutional p-4 sm:p-8 border border-border">
      <div className="flex items-center space-x-3 mb-2 sm:mb-4">
        <div className="flex items-center justify-center w-10 h-10 bg-accent/10 rounded-lg">
          <Icon
            name="EnvelopeIcon"
            size={24}
            variant="outline"
            className="text-accent"
          />
        </div>
        <h3 className="font-headline text-2xl font-semibold text-foreground">
          Quarterly Updates
        </h3>
      </div>

      <p className="font-body text-base text-text-secondary leading-relaxed mb-2 sm:mb-6">
        Subscribe to receive detailed progress reports, impact metrics, and strategic insights on our 20-year transformation agenda.
      </p>

      <form onSubmit={handleSubmit} className="space-y-2 sm:space-y-4">
        <div>
          <label
            htmlFor="newsletter-email"
            className="block font-body text-sm font-medium text-foreground mb-2"
          >
            Email Address
          </label>
          <input
            type="email"
            id="newsletter-email"
            value={email}
            onChange={(e) => setEmail(e.target.value)}
            placeholder="investor@example.com"
            required
            className="w-full px-4 py-1 sm:py-3 font-body text-base text-foreground bg-background border border-input rounded-md focus:outline-none focus:ring-2 focus:ring-ring transition-all duration-300"
          />
        </div>

        <button
          type="submit"
          disabled={isSubmitting}
          className="w-full flex items-center justify-center space-x-2 px-6 py-1 sm:py-3 bg-secondary text-secondary-foreground font-body font-medium text-base rounded-md hover:bg-secondary/90 disabled:opacity-50 disabled:cursor-not-allowed transition-all duration-300"
        >
          <Icon
            name={isSubmitting ? 'ArrowPathIcon' : 'PaperAirplaneIcon'}
            size={20}
            variant="outline"
            className={isSubmitting ? 'animate-spin' : ''}
          />
          <span>{isSubmitting ? 'Subscribing...' : 'Subscribe to Updates'}</span>
        </button>
      </form>

      <p className="font-body text-xs text-muted-foreground text-center mt-4">
        We respect your privacy. Unsubscribe at any time.
      </p>
    </div>
  );
}